import { render, staticRenderFns } from "./GamesLeague.vue?vue&type=template&id=566cf81c&scoped=true&"
import script from "./GamesLeague.vue?vue&type=script&lang=js&"
export * from "./GamesLeague.vue?vue&type=script&lang=js&"
import style0 from "./GamesLeague.vue?vue&type=style&index=0&id=566cf81c&prod&lang=css&"
import style1 from "./GamesLeague.vue?vue&type=style&index=1&id=566cf81c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566cf81c",
  null
  
)

export default component.exports